import React from "react";
import PropTypes from "prop-types";
import { Form } from "@domestika-dev/prudencio/dist/atoms/Form";
import { Grid, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";

const MadeAtSelectors = ({
  days,
  months,
  years,
  dayPublished,
  monthPublished,
  yearPublished,
  label,
  dayPlaceholderMessage,
  monthPlaceholderMessage,
  yearPlaceholderMessage,
  onSelectedDate,
  ...rest
}) => {
  return (
    <Form.Field size="small" label={label} {...rest}>
      <Grid
        gridColumnGap={[1, 2, 2]}
        gridRowGap={[6, 6, 6]}
        gridTemplateColumns={["1fr 1fr 1fr", "1fr 1fr 1fr", "1fr 1fr 1fr"]}
        gridTemplateArea={[". . .", ". . .", ". . ."]}
      >
        <GridItem>
          <Form.Select
            size="medium"
            name="dayPublished"
            defaultValue={dayPublished}
            onSelected={selected => onSelectedDate(selected, "dayPublished")}
            options={days}
            placeholderMessage={dayPlaceholderMessage}
            {...{ "data-label": "project-day-published" }}
          />
        </GridItem>

        <GridItem>
          <Form.Select
            size="medium"
            name="monthPublished"
            options={months}
            defaultValue={months.find(element => element.value === monthPublished)?.label || ""}
            onSelected={selected => onSelectedDate(selected, "monthPublished")}
            placeholderMessage={monthPlaceholderMessage}
            {...{ "data-label": "project-month-published" }}
          />
        </GridItem>

        <GridItem>
          <Form.Select
            size="medium"
            name="yearPublished"
            options={years}
            defaultValue={yearPublished}
            onSelected={selected => onSelectedDate(selected, "yearPublished")}
            placeholderMessage={yearPlaceholderMessage}
            {...{ "data-label": "project-year-published" }}
          />
        </GridItem>
      </Grid>
    </Form.Field>
  );
};

export default MadeAtSelectors;

MadeAtSelectors.propTypes = {
  days: PropTypes.array,
  months: PropTypes.array,
  years: PropTypes.array,
  dayPublished: PropTypes.number,
  monthPublished: PropTypes.number,
  yearPublished: PropTypes.number,
  label: PropTypes.string,
  dayPlaceholderMessage: PropTypes.string,
  monthPlaceholderMessage: PropTypes.string,
  yearPlaceholderMessage: PropTypes.string,
  onSelectedDate: PropTypes.func,
};

MadeAtSelectors.defaultProps = {
  days: [],
  months: [],
  years: [],
  dayPublished: null,
  monthPublished: null,
  yearPublished: null,
  label: "",
  dayPlaceholderMessage: "",
  monthPlaceholderMessage: "",
  yearPlaceholderMessage: "",
  onSelectedDate: () => {},
};
